import { Skeleton } from "@/app/components/shadcn/skeleton";

const AllCategoriesNavigationSkeleton = () => {
  return (
    <div className="mega-menu-panel mx-auto flex overflow-hidden">
      {/* Left sidebar skeleton */}
      <div className="min-w-48.75 bg-muted p-2 space-y-2">
        {Array.from({ length: 8 }).map((_, i) => (
          <div key={i} className="flex items-center justify-between py-3 px-3">
            <div className="flex items-center gap-2 flex-1">
              <Skeleton className="w-5 h-5 rounded" />
              <Skeleton className="h-4 w-24" />
            </div>
            <Skeleton className="w-4 h-4" />
          </div>
        ))}
      </div>

      {/* Right content skeleton */}
      <div className="grow p-4 space-y-6">
        {Array.from({ length: 3 }).map((_, i) => (
          <div key={i} className="space-y-3">
            <div className="flex items-center gap-3">
              <Skeleton className="w-16 h-16 rounded-full" />
              <Skeleton className="h-5 w-32" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllCategoriesNavigationSkeleton;